import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useGames } from '@/Context/GameContext';
import styles from './GamingCards.module.css';

/**
 * Gaming Cards Component
 * Displays main game categories in horizontal scrollable layout
 * Matches the experience cards structure
 */
const GamingCards = () => {
  const navigate = useNavigate();
  const cardListRef = useRef(null);
  const { handleJsGameLaunch } = useGames();

  const SPORTSBOOK_GAME_ID = '4d31f1186a81e208c003a7e37411ce35';

  const cards = [
    {
      id: 'casino',
      title: 'Casino',
      backgroundImage: '/assets/images/background-image-default.webp',
      categoryImage: '/assets/images/casino.webp',
      link: '/casino',
    },
    {
      id: 'live-casino',
      title: 'Live Casino',
      backgroundImage: '/assets/images/background-image-default.webp',
      categoryImage: '/assets/images/achievments.webp',
      link: '/casino/live-casino',
    },
    {
      id: 'slots',
      title: 'Slots',
      backgroundImage: '/assets/images/background-image-default.webp',
      categoryImage: '/assets/images/live-casino.webp',
      link: '/casino/popular-slots',
    },
 
    {
      id: 'sports',
      title: 'Sports',
      backgroundImage: '/assets/images/background-image-default.webp',
      categoryImage: '/assets/images/sport.webp',
      link: '/sports',
    },
       {
      id: 'Bonus',
      title: 'Bonus',
      backgroundImage: '/assets/images/background-image-default.webp',
    categoryImage: '/assets/images/missions.webp',
      // categoryImage: '/assets/images/bonus.webp',
      link: '/bonus-page',
    },
    // {
    //   id: 'missions',
    //   title: 'Missions',
    //   backgroundImage: '/assets/images/background-image-default.webp',
    //   categoryImage: '/assets/images/missions.webp',
    //   link: '/rewards/missions',
    // },
    // {
    //   id: 'tournaments',
    //   title: 'Tournaments',
    //   backgroundImage: '/assets/images/background-image-default.webp',
    //   categoryImage: '/assets/images/tournaments.webp',
    //   link: '/rewards/tournaments',
    // },
  
  
    // {
    //   id: 'turbo-10',
    //   title: 'Turbo 10',
    //   backgroundImage: '/assets/images/background-image-default.webp',
    //   categoryImage: '/assets/images/gaming-cards/mega-match.png',
    //   link: '/rewards/turbo-10',
    // },
  ];

  const handleCardClick = (card) => {
    if (card.id === 'sports') {
      handleJsGameLaunch(SPORTSBOOK_GAME_ID, navigate, 'SPORTSBOOK');
      return;
    }
    navigate(card.link);
  };

  const handleScrollLeft = () => {
    if (cardListRef.current) {
      const scrollAmount = cardListRef.current.clientWidth * 0.8; // Scroll 80% of visible width
      cardListRef.current.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleScrollRight = () => {
    if (cardListRef.current) {
      const scrollAmount = cardListRef.current.clientWidth * 0.8; // Scroll 80% of visible width
      cardListRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Your Ultimate Gaming Experience</h2>
      </div>

      <div className={styles.cardListWrapper}>
        <div className={styles.cardList} ref={cardListRef}>
          {cards.map((card) => (
            <a
              key={card.id}
              id={`experienceCard-${card.id}`}
              href={card.link}
              className={styles.card}
              onClick={(e) => {
                e.preventDefault();
                handleCardClick(card);
              }}
            >
              <img
                alt={card.title}
                src={card.backgroundImage}
                className={styles.background}
                onError={(e) => {
                  e.target.src = '/assets/images/default_card3.png';
                }}
              />
              <img
                alt={card.title}
                src={card.categoryImage}
                className={styles.category}
                onError={(e) => {
                  e.target.src = '/assets/images/placeholder.png';
                }}
              />
              <p className={styles.cardTitle}>{card.title}</p>
            </a>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      <div className={styles.controllers}>
        <div className={styles.buttons}>
          <div

            onClick={handleScrollLeft}
            aria-label="Scroll left"
          >
            <FontAwesomeIcon
              icon={faAngleLeft}
              className={styles.doubleArrowLeft}
              style={{ fontSize: '20px' }}
            />
            <FontAwesomeIcon
              icon={faAngleLeft}
              className={styles.doubleArrowLeft}
              style={{ fontSize: '20px' }}
            />
          </div>
          <div

            onClick={handleScrollRight}
            aria-label="Scroll right"
          >
            <FontAwesomeIcon
              icon={faAngleRight}
              className={styles.doubleArrowRight}
              style={{ fontSize: '20px' }}
            />
            <FontAwesomeIcon
              icon={faAngleRight}
              className={styles.doubleArrowRight}
              style={{ fontSize: '20px' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamingCards;
